import type { DataQualityFlag } from './privileged-access'

// Keyed by every API flag and every client-side flag, so tsc fails when a new code has no badge.
export type FlagCode = 'grant_without_definition' | 'malformed_issuer_id' | 'no_issuer_ids' | DataQualityFlag

export const FLAG_BADGE: Record<FlagCode, { label: string; variant: 'error' | 'warning' }> = {
  grant_without_definition: { label: 'Grants with no definition', variant: 'error' },
  malformed_issuer_id: { label: 'Malformed issuer ID', variant: 'error' },
  no_issuer_ids: { label: 'No issuer IDs', variant: 'warning' },
  case_variant_duplicate: { label: 'Case duplicate', variant: 'warning' },
  malformed_name: { label: 'Malformed name', variant: 'warning' },
  ignored_wildcard: { label: 'Wildcard ignored', variant: 'warning' },
}

export const isFlagCode = (f: string): f is FlagCode => f in FLAG_BADGE
